import type { ProductGenre } from '@/app/lib/api/types-api'
import { resolveProductGenre } from '@/app/lib/utils'

import { OWN_RATING_CATEGORIES } from './constants'
import type { RatingSystem } from './types'

/**
 * Decide el sistema de valoraciones de la PDP de un producto (spec.md
 * FR-001/FR-002/FR-018): `'own'` para conciertos/festivales/deporte, `'bazaarvoice'`
 * para el resto (incluida categoría ausente/no reconocida — edge case documentado
 * en spec.md). Fuente primaria: el segmento de categoría de la propia URL
 * (`categoriaSlug`, ya disponible sin red en `[slug]/[slug2]/page.tsx`, ver
 * research.md R1); `genres` de la respuesta de la PDP actúa como confirmación de
 * respaldo, nunca como única fuente (evitaría decidir el sistema sin esperar a
 * la API).
 */
export function resolveRatingSystem(
  categoriaSlug: string,
  genres?: ProductGenre[] | null,
): RatingSystem {
  const normalizedCategoria = categoriaSlug.trim().toLowerCase()
  const genreNicename = resolveProductGenre(genres)?.nicename?.trim().toLowerCase()

  const isOwnCategory =
    OWN_RATING_CATEGORIES.includes(normalizedCategoria as (typeof OWN_RATING_CATEGORIES)[number]) ||
    (genreNicename != null &&
      OWN_RATING_CATEGORIES.includes(genreNicename as (typeof OWN_RATING_CATEGORIES)[number]))

  return isOwnCategory ? 'own' : 'bazaarvoice'
}
